import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FileText, ShieldCheck } from 'lucide-react';
import Propositions from './Propositions';
import Contrats from './Contrats';

type Tab = 'propositions' | 'contrats';

export default function PropositionsContrats() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const initial = (params.get('tab') as Tab) || 'propositions';
  const [tab, setTab] = useState<Tab>(initial);

  useEffect(() => {
    const t = (new URLSearchParams(location.search).get('tab') as Tab) || 'propositions';
    setTab(t);
  }, [location.search]);

  const changeTab = (t: Tab) => {
    setTab(t);
    const sp = new URLSearchParams(location.search);
    sp.set('tab', t);
    navigate({ search: sp.toString() }, { replace: true });
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2 border-b border-slate-800">
        <button
          onClick={() => changeTab('propositions')}
          className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
            tab === 'propositions'
              ? 'border-amber-400 text-amber-400'
              : 'border-transparent text-slate-400 hover:text-slate-200'
          }`}
        >
          <FileText size={15} strokeWidth={1.5} />
          Propositions
        </button>
        <button
          onClick={() => changeTab('contrats')}
          className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
            tab === 'contrats'
              ? 'border-amber-400 text-amber-400'
              : 'border-transparent text-slate-400 hover:text-slate-200'
          }`}
        >
          <ShieldCheck size={15} strokeWidth={1.5} />
          Contrats
        </button>
      </div>
      {tab === 'propositions' ? <Propositions /> : <Contrats />}
    </div>
  );
}
